<template>
  <form @submit.prevent="addStakeholderByAgent">
    <h3 class="mt-0">
      {{ $t('stakeholderselection.title') }}
    </h3>

    <label
      for="selectStakeholder"
      class="required-input"
    >{{ $t('stakeholderselection.stakeholder') }}</label>
    <Dropdown
      id="selectStakeholder"
      v-model="selectedStakeholder"
      :placeholder="$t('stakeholderselection.select')"
      :options="existingStakeholders"
      :option-label="(stakeholder) => stakeholder.stakeholderId"
      class="col-12 mt-2 p-0"
      filter
      @change="v$.$reset()"
    />

    <div class="my-2">
      <b>{{ $t('stakeholderselection.or') }}</b>
    </div>

    <div class="p-input mb-3">
      <label
        for="name"
        class="required-input"
      >{{ $t('stakeholderselection.new') }}</label>
      <InputText
        id="name"
        v-model="v$.stakeholder.name.$model"
        :placeholder="$t('entity.stakeholder.name')"
        class="col-12 mt-2"
        :class="{'invalid-input': v$.stakeholder.name.$error }"
        type="text"
        required
      />
      <div
        v-for="error of v$.stakeholder.name.$errors"
        :key="error.$uid"
        class="input-errors"
      >
        <div class="error-msg">
          {{ error.$message }}
        </div>
      </div>
    </div>

    <Message
      v-if="errors.length > 0"
      severity="error"
      :closable="false"
    >
      <ul class="list-none m-0 p-0">
        <li
          v-for="error of errors"
          :key="error"
        >
          {{ $t(error) }}
        </li>
      </ul>
    </Message>

    <div class="my-3 flex justify-content-center flex-wrap">
      <Button
        v-show="!addButtonDisabled"
        type="submit"
        :label="$t('action.crud.create')"
        icon="pi pi-save"
        :loading="isSaving"
        class="p-button-rounded p-button-outlined"
      />
    </div>
  </form>
</template>

<script>
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Message from 'primevue/message';
import {useVuelidate} from '@vuelidate/core';
import {maxLength, required} from '@/i18n/i18nValidators';
import Dropdown from "primevue/dropdown";
import {reactive} from "vue";
import useStakeholderFilter from "@/composables/filters/useStakeholderFilter";

export default {
  name: 'StakeholderSelectionComponent',
  components: {Dropdown, InputText, Button, Message},
  props: {
    modelValue: {
      type: Object,
      default: null
    }
  },
  emits: ['update:modelValue'],
  setup() {
    const stakeholderFilter = reactive(useStakeholderFilter())
    stakeholderFilter.pageable.size = 1000;
    stakeholderFilter.filters.locked.value = false;
    return {
      stakeholderFilter,
      v$: useVuelidate()
    }
  },
  data() {
    return {
      existingStakeholders: [],
      stakeholder: {
        name: null
      },
      isSaving: false,
      errors: []
    }
  },
  validations() {
    return {
      stakeholder: {
        name: {required, maxLength: maxLength(50)}
      }
    }
  },
  computed: {
    addButtonDisabled() {
      return this.v$.$invalid;
    },
    selectedStakeholder: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    },
  },
  async mounted() {
    this.existingStakeholders = (await this.$stakeHolderService.fetchStakeholdersPagingAndSorting(this.stakeholderFilter.getQueryParams())).content;
  },
  methods: {
    async addStakeholderByAgent() {
      this.errors = [];
      const isFormValid = await this.v$.$validate();
      if (!isFormValid) return;

      this.isSaving = true;
      try {
        const newStakeholder = await this.$stakeHolderService.addStakeholderByAgent(this.stakeholder);
        if (newStakeholder) {
          this.existingStakeholders.push(newStakeholder);
          this.selectedStakeholder = newStakeholder;
          this.$emitter.emit('toast', {severity: 'success', message: 'stakeholderpage.messages.createSuccess'});
          this.stakeholder.name = null;
          this.v$.$reset();
        }
      } catch (e) {
        this.errors = e.response.data;
      } finally {
        this.isSaving = false;
      }
    }
  }
}
</script>


